import AutoAwesomeOutlined from '@mui/icons-material/AutoAwesomeOutlined';
import ImageOutlined from '@mui/icons-material/ImageOutlined';
import InsertChartOutlinedOutlined from '@mui/icons-material/InsertChartOutlinedOutlined';
import ViewCarouselOutlined from '@mui/icons-material/ViewCarouselOutlined';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import type { ComponentType } from 'react';

export function outcomeIcon(kind: string): ComponentType<SvgIconProps> {
  if (kind === 'brief') return AutoAwesomeOutlined;
  if (kind === 'storyboard') return ViewCarouselOutlined;
  return kind === 'banner' || kind === 'banner_storyboard'
    ? ImageOutlined
    : InsertChartOutlinedOutlined;
}
